export const defaultProfileMenu = [
  {
    Type: 'PAGE',
    href: '',
    id: 'profileMenuProfile',
    Text: 'Profile',
    action: {
      predefined: {
        0: {
          action: 'SmartV Profile',
        },
      },
    },
  },
  {
    Type: 'PAGE',
    href: '',
    id: 'profileMenuSignOut',
    Text: 'Sign Out',
    action: {
      predefined: {
        0: {
          action: 'SmartV Logout',
        },
      },
    },
  },
]
